// Zentrale Menü-Definition – von Sidebar und Menü-Konfiguration gemeinsam genutzt.
import type { IconName } from '../components/ui';

export interface MenuItem {
  key: string;          // eindeutiger Schlüssel (= Sektion für globale Sichtbarkeit)
  path: string;
  label: string;
  icon: IconName;       // Linien-Symbol aus components/ui (Icon.*), keine Emojis
  adminOnly?: boolean;  // nur für Admins sichtbar
  alwaysVisible?: boolean; // kann nicht global ausgeblendet werden (kein Aussperren)
  unterpunkte?: MenuItem[]; // selten genutzte Seiten – nur eingeblendet, solange man im Bereich ist
}

export interface MenuGroup {
  key: string;
  label: string;
  items: MenuItem[];
}

export const MENU_GROUPS: MenuGroup[] = [
  {
    key: 'start',
    label: 'Start',
    items: [
      { key: 'dashboard', path: '/dashboard', label: 'Dashboard', icon: 'Dashboard', alwaysVisible: true },
    ],
  },
  {
    key: 'kunden',
    label: 'Kunden & Vertrieb',
    items: [
      {
        key: 'kunden', path: '/kunden', label: 'Kunden', icon: 'Kunden',
        unterpunkte: [
          { key: 'karte', path: '/karte', label: 'Karte', icon: 'Karte' },
          { key: 'potenziale', path: '/potenziale', label: 'Potenziale', icon: 'Ziel' },
        ],
      },
      { key: 'beratungstermine', path: '/beratungstermine', label: 'Beratungstermine', icon: 'Kalender' },
    ],
  },
  {
    key: 'auftraege',
    label: 'Aufträge',
    items: [
      { key: 'berichte', path: '/berichte', label: 'Berichte', icon: 'Bericht' },
      { key: 'protokolle', path: '/protokolle', label: 'Inbetriebnahme', icon: 'Protokoll' },
      { key: 'waren', path: '/waren', label: 'Artikel', icon: 'Paket' },
      { key: 'bauteile', path: '/bauteile', label: 'Elektrobauteile', icon: 'Blitz' },
      { key: 'aufgaben', path: '/aufgaben', label: 'Aufgaben', icon: 'Aufgaben' },
    ],
  },
  {
    key: 'personal',
    label: 'Personal & Zeit',
    items: [
      { key: 'arbeitszeiten', path: '/arbeitszeiten', label: 'Arbeitszeiten', icon: 'Uhr' },
      { key: 'urlaub', path: '/urlaub', label: 'Urlaub', icon: 'Urlaub' },
      { key: 'zeiterfassung', path: '/zeiterfassung', label: 'Zeiterfassung', icon: 'Diagramm', adminOnly: true },
      { key: 'personal-konfiguration', path: '/personal-konfiguration', label: 'Personal-Konfig.', icon: 'Regler', adminOnly: true },
    ],
  },
  {
    key: 'administration',
    label: 'Administration',
    items: [
      { key: 'menue-konfiguration', path: '/menue-konfiguration', label: 'Menü-Konfig.', icon: 'Raster', adminOnly: true, alwaysVisible: true },
      { key: 'protokoll-konfiguration', path: '/protokoll-konfiguration', label: 'Protokoll-Konfig.', icon: 'Werkzeug', adminOnly: true },
      { key: 'users', path: '/users', label: 'Benutzerverwaltung', icon: 'Schild', adminOnly: true, alwaysVisible: true },
    ],
  },
];

/** Sichtbar nach Rolle + globaler Sichtbarkeit. */
export const istSichtbar = (
  item: MenuItem,
  isAdmin: boolean,
  sichtbarkeit: Record<string, boolean>
): boolean => {
  if (item.adminOnly && !isAdmin) return false;
  if (item.alwaysVisible) return true;
  return sichtbarkeit[item.key] !== false;
};
